import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    const isAuthCall = /\/auth\/(me|login|logout|mfa|change-password)/.test(url);
    const onPublic = ["/login", "/super-admin-login", "/apply-loan", "/status"].includes(window.location.pathname);
    if (error.response?.status === 401 && !isAuthCall && !onPublic) {
      const d = error.response.data?.detail;
      sessionStorage.setItem("omi-logout-reason", typeof d === "string" ? d : "Your session ended. Please sign in again.");
      window.location.assign(loginPath());
    }
    return Promise.reject(error);
  },
);

export const loginPath = () => (localStorage.getItem("omi-portal") === "admin" ? "/super-admin-login" : "/login");

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return JSON.stringify(detail);
}
